import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { articleService } from '../services/api';
import { useTheme, useBrand } from '../context/ColorContext';
import { ChevronLeft, Calendar, User, Loader2 } from 'lucide-react';

const ArticleDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { activeBrand } = useBrand();
    const isDark = theme === 'dark';

    const { data: article, isLoading } = useQuery({
        queryKey: ['article', slug],
        queryFn: () => articleService.getBySlug(slug)
    });

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="animate-spin text-slate-400" size={48} />
            </div>
        );
    }

    if (!article) {
        return (
            <div className={`min-h-screen flex flex-col items-center justify-center ${isDark ? 'text-white' : 'text-slate-900'}`}>
                <h2 className="text-2xl font-bold mb-4">İçerik bulunamadı.</h2>
                <button
                    onClick={() => navigate(`/${activeBrand.id}/ilham`)}
                    className="px-6 py-2 text-white rounded-full uppercase tracking-widest font-bold"
                    style={{ backgroundColor: activeBrand.primaryColor }}
                >
                    İlhama Dön
                </button>
            </div>
        );
    }

    return (
        <div className={`min-h-screen pt-32 pb-20 px-4 md:px-0 container mx-auto ${isDark ? 'text-white' : 'text-slate-900'}`}>
            <button
                onClick={() => navigate(`/${activeBrand.id}/ilham`)}
                className="flex items-center gap-2 mb-8 opacity-60 hover:opacity-100 transition-opacity uppercase text-xs font-bold tracking-[0.2em]"
            >
                <ChevronLeft size={20} /> İlhamlara Dön
            </button>

            <article className="max-w-4xl mx-auto">
                <header className="mb-12 text-center">
                    {article.tag && (
                        <span className="inline-block px-4 py-2 rounded-full border text-[10px] font-black uppercase tracking-widest mb-6 border-slate-200 dark:border-white/20">
                            {article.tag}
                        </span>
                    )}
                    <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-tight mb-6">
                        {article.title}
                    </h1>
                    <div className="flex items-center justify-center gap-6 opacity-60 text-sm font-medium">
                        <span className="flex items-center gap-2"><Calendar size={16} /> {new Date(article.createdAt).toLocaleDateString('tr-TR')}</span>
                    </div>
                </header>

                {article.image && (
                    <div className="relative aspect-video md:aspect-[21/9] rounded-[2rem] overflow-hidden mb-16 shadow-2xl">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover" />
                    </div>
                )}

                <div className="prose prose-lg md:prose-xl dark:prose-invert max-w-none prose-headings:font-black prose-headings:uppercase prose-p:leading-relaxed mx-auto">
                    {/* Render rich text content */}
                    <div dangerouslySetInnerHTML={{ __html: article.content }} />
                </div>
            </article>
        </div>
    );
};

export default ArticleDetail;
